import pick from 'lodash/pick'

import { Address, Store } from '../../types'

// could be undefined if the address does not exist yet
const toStoreAddressForm = (billingAddress: Address | undefined) =>
  pick(billingAddress, [
    'firstName',
    'lastName',
    'companyName',
    'lineOne',
    'city',
    'state',
    'country',
    'postalCode',
  ])

const toStorePolicyForm = (store: Store) => ({
  shippingInfo: store.shippingInfo || '',
  returnPolicy: store.returnPolicy || '',
  description: store.description || '',
})

export default { toStoreAddressForm, toStorePolicyForm }
